var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoreResult(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.141 12.51a1 1 0 01.849 1.131l-.674 4.718a1 1 0 00.99 1.141h11.388a1 1 0 00.99-1.141l-.674-4.718a1 1 0 011.98-.282l.674 4.717a3 3 0 01-2.97 3.424H6.306a3 3 0 01-2.97-3.424l.674-4.717a1 1 0 011.131-.849z",
    fill: "#9B9CA2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.5s1-1 3-1 3 1 3 1v6a2 2 0 01-2 2h-2a2 2 0 01-2-2v-6zm-4.14-.323c-.561.16-.942.649-1.083 1.215L2.62 9.015A2 2 0 004.56 11.5H6a2 2 0 002-2v-6S7 3 6 3c-.402 0-.803.08-1.14.177zM10 19.5v-2a2 2 0 114 0v2h-4zM18 3c-1 0-2 .5-2 .5v6a2 2 0 002 2h1.438a2 2 0 001.94-2.485l-1.155-4.623c-.142-.566-.522-1.054-1.083-1.215A4.229 4.229 0 0018 3z",
    fill: "#9B9CA2"
  })));
}
export default SvgStoreResult;